import ServicePrice from './ServicePrice';

export default ServicePrice;
